export default [
  {
    path: '/admin/trader/position-guardian',
    name: 'PositionGuardian',
    component: () => import('@/views/Admin/Trader/PositionGuardian/Index.vue'),
    meta: {
      pageTitle: 'Position Guardian',
      breadcrumb: [
        { text: 'Trader', active: false },
        { text: 'Position Guardian', active: true },
      ],
      resource: 'targets.list',
      action: 'read',
    },
  },
]
